export const READ_OPTIMIZED_POST_VALUE_VERSION = 1;

/**
 * Reader trust metadata only needs a deterministic stale-data guard, not a
 * cryptographic digest. This small synchronous hash can run during render on
 * the client and match the Functions-side implementation exactly.
 */
// ** IMPORTANT **: Keep in sync with functions/src/readOptimizedPostValue.ts
export function buildReadOptimizedPostValueHash(value?: string): string {
    const normalizedValue = typeof value === 'string' ? value : '';
    let hash = 2166136261;

    for (let i = 0; i < normalizedValue.length; i += 1) {
        // Intentional 32-bit xor to keep the shared hash stable across runtimes.
        // eslint-disable-next-line no-bitwise
        hash ^= normalizedValue.charCodeAt(i);
        hash = Math.imul(hash, 16777619);
    }

    // Intentional unsigned 32-bit coercion so the serialized digest is stable.
    // eslint-disable-next-line no-bitwise
    return `${normalizedValue.length}:${(hash >>> 0).toString(16).padStart(8, '0')}`;
}
